import { Component } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';




@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  constructor(private router: Router) { }


public navigateTo(path: string): void {
  this.router.navigate([path]);
}



}